import React from 'react';

// Logo Vodafone (asset in public/). Mostrato accanto al risultato 456 quando la linea è Vodafone.
const SRC = `${process.env.PUBLIC_URL || ''}/vodafone.png`;

export default function VodafoneBadge({ size = 16, title = 'Linea Vodafone', style }) {
  return (
    <img src={SRC} alt="Vodafone" title={title} width={size} height={size}
      style={{ display: 'inline-block', verticalAlign: 'middle', objectFit: 'contain', ...style }} />
  );
}
